<template>
  <q-card-actions
    class="actions q-py-md q-px-xs-sm q-px-sm-lg"
    :class="{ 'bg-black': props.dark, 'bg-primary': !props.dark }"
  >
    <div class="row justify-end q-gutter-xs-sm q-gutter-sm-md full-width">
      <slot></slot>
    </div>
  </q-card-actions>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    dark?: boolean;
  }>(),
  {
    dark: false,
  },
);
</script>

<style scoped lang="scss">
.actions {
  border-top: 1px solid rgb(0 0 0 / 10%);
}
</style>
